import request from '../../utils/request';

// Monitoring → Webhook errors. Cross-order list of webhook calls that did not
// return a 2xx, plus a count for the menu badge and a per-row delete.
export function getWebhookErrors(params) {
  return request('/webhook-logs/errors', { method: 'GET', params });
}

export function getWebhookErrorCount() {
  return request('/webhook-logs/errors/count', { method: 'GET' });
}

export function deleteWebhookLog(id) {
  return request(`/webhook-logs/${id}`, { method: 'DELETE' });
}

export function deleteAllWebhookErrors() {
  return request('/webhook-logs/errors', { method: 'DELETE' });
}

export function deleteWebhookLogsByIds(ids) {
  return request('/webhook-logs/bulk-delete', { method: 'POST', data: { ids } });
}

// Webhook config for the admin UI (effective global default rate, etc.).
export function getWebhookConfig() {
  return request('/webhook-logs/config', { method: 'GET' });
}

// OVO-226 — resend/backfill dropped webhooks. Default (force=false) only sends
// the missing/failed ones (idempotent); force=true re-sends every order.
export function resendRouteWebhooks(routeId, force = false) {
  return request(`/webhook-logs/resend-route/${routeId}`, {
    method: 'POST',
    data: { force },
  });
}

// Route 2639 (Sep 2026) — re-announce the CURRENT partner-relative position
// (ET `sort`, standard `partner_relative_order`…) of every partner order on the
// route whose last delivered order.dispatched carried a different one.
// Idempotent: a second call finds nothing changed.
export function reannounceRouteWebhooks(routeId) {
  return request(`/webhook-logs/reannounce-route/${routeId}`, { method: 'POST' });
}

export function resendOrderWebhook(orderCode, force = false) {
  return request(`/webhook-logs/resend-order/${orderCode}`, {
    method: 'POST',
    data: { force },
  });
}
